import React from "react";
import { Controller, get, useFormContext } from "react-hook-form";
import {
  FormControl,
  InputLabel,
  FormHelperText,
  MenuItem,
  Select,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { CountryRegionData } from "react-country-region-selector";

const CountrySelector = ({
  countryName = "clinic.country",
  preselectedValue,
  minWidth = 500,
  size,
  testId = "auth.signup.country-select",
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();

  const countries = CountryRegionData.map((country) => ({
    key: country[1],
    value: country[0],
    label: t(country[0]),
  }))
    .sort((a, b) => a.label.localeCompare(b.label))
    .map((country) => (
      <MenuItem
        key={country.key}
        value={country.value}
        data-testid={`${testId}.option.${country.key}`}
      >
        {country.label}
      </MenuItem>
    ));

  const label = t("Country");
  // Look the error up by the field's own path - it isn't always "clinic.country"
  const fieldError = get(errors, countryName);

  return (
    <FormControl fullWidth error={!!fieldError}>
      <InputLabel htmlFor={countryName}>{label}</InputLabel>
      <Controller
        name={countryName}
        control={control}
        defaultValue={preselectedValue ?? ""}
        rules={{ required: t("CantBeEmpty") }}
        render={({ field }) => (
          <Select
            size={size}
            {...field}
            fullWidth
            label={label}
            data-testid={testId}
            onChange={(event) => field.onChange(event.target.value)}
          >
            <MenuItem value="" disabled>
              {t("SelectACountry")}
            </MenuItem>
            {countries}
          </Select>
        )}
      />
      <FormHelperText>{fieldError?.message}</FormHelperText>
    </FormControl>
  );
};

export default CountrySelector;
